import Cookies from "universal-cookie";
const cookie = new Cookies();

export const makeAuthHeader = () => {
  if (getUser() && getUser().token) {
    return {
      Authorization: getUser().token
    };
  }
  return null;
};

export const clearUser = () =>
  cookie.remove("_wsa.user", { path: "/", domain: process.env.DOMAIN });
export const getUser = () => cookie.get("_wsa.user");
export const setUser = payload =>
  cookie.set("_wsa.user", payload, { path: "/", domain: process.env.DOMAIN });



// WEBPACK FOOTER //
// ./src/utils/auth.js